import {CREATE_POSTED_NOTE, DELETE_POSTED_NOTE, EDIT_POSTED_NOTE, GET_POSTED_NOTE} from './postedNote.types';

export const getPostedNote = (clientId, load) => ({
    type: GET_POSTED_NOTE,
    payload: {clientId, load},
});

export const createPostedNote = (clientId, body) => ({
    type: CREATE_POSTED_NOTE,
    payload: {clientId, body},
});

export const editPostedNote = (clientId, body) => ({
    type: EDIT_POSTED_NOTE,
    payload: {clientId, body},
});

export const deletePostedNote = (clientId) => ({
    type: DELETE_POSTED_NOTE,
    payload: {clientId},
});
